import { useMemo } from 'react';
import DataCacheService from '@/shared/services/DataCacheService';
import { getRegistrationOverviewNavParams } from '../budgetHelpers';
export const useRegistrationOverviewNavParams = (year, relationId, invoiceStreamId, companyId) => useMemo(() => {
    const { budgetIncludeExForfait = true, budgetIncludeInForfait = true, budgetIncludeNotBillable = false, budgetOnlyNumberedInvoices = false, } = DataCacheService.getCompanySettings(companyId);
    return getRegistrationOverviewNavParams(year, relationId, invoiceStreamId, {
        includeExForfait: budgetIncludeExForfait,
        includeInForfait: budgetIncludeInForfait,
        includeNotBillable: budgetIncludeNotBillable,
        onlyNumberedInvoices: budgetOnlyNumberedInvoices,
    });
}, [year, relationId, invoiceStreamId, companyId]);
